import react from "react";

import Numero1 from "../images/commercials/Numero/KHAYELITSHA_NEW HOME__04 Large.jpeg";
import Numero2 from "../images/commercials/Numero/KHAYELITSHA_NEW HOME__12 Large.jpeg";
import Numero3 from "../images/commercials/Numero/KHAYELITSHA_NEW HOME__14 copy Large.jpeg";
import Numero4 from "../images/commercials/Numero/KHAYELITSHA_NEW HOME__18 Large.jpeg";
import Numero5 from "../images/commercials/Numero/07FINAL Large.jpeg";

const Numero = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={Numero1} alt="Numero Homme - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={Numero2} alt="Numero Homme - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={Numero3} alt="Numero Homme - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={Numero4} alt="Numero Homme - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={Numero5} alt="Numero Homme - Image 5"/>
                </div>
            </div>
        </div>
    );
}

export default Numero;